// ============================================================================
// JARVISTRAVEL - AUTH ROUTES (JAR-1420)
// The signed-out screens' paths, each written once. App's routes, every
// navigate to one and the invitation link read them from here, so a renamed
// route can't leave a link pointing at the old one. The MFA setup screen's is
// SETUP_MFA_PATH, beside the session task that sends people to it.
// ============================================================================

/** Every signed-out screen lives under this. */
export const AUTH_PREFIX = '/auth/';

export const SIGN_IN_PATH = '/auth/sign-in';
export const SIGN_UP_PATH = '/auth/sign-up';
export const FORGOT_PASSWORD_PATH = '/auth/forgot-password';
export const VERIFY_EMAIL_PATH = '/auth/verify-email';
